module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "site-header"
    }
  }, [_vm._m(0), " ", _h('nav', {
    attrs: {
      "id": "site-nav"
    }
  }, [_h('ul', [_h('li', [_h('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, ["Portfolio"])]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": "/about"
    }
  }, ["About Me"])]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, ["Contact"])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('header', [_h('h1', ["Rommel Santor"]), " ", _h('h2', ["Web Developer"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14c4a71a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 48
// module chunks = 1